import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

const STATUSES = ["all", "running", "complete", "failed", "cancelled"] as const;

interface PipelineFiltersProps {
  value: string;
  onChange: (status: string) => void;
}

export function PipelineFilters({ value, onChange }: PipelineFiltersProps) {
  const { t } = useTranslation();
  return (
    <div className="flex gap-2" role="group" aria-label={t("projectPortal.pipelines.filters.label")}>
      {STATUSES.map((status) => (
        <Button
          key={status}
          variant={value === status ? "default" : "outline"}
          size="sm"
          onClick={() => onChange(status)}
          aria-pressed={value === status}
        >
          {t(`projectPortal.pipelines.filters.${status}`)}
        </Button>
      ))}
    </div>
  );
}
